import React, { Component, PropTypes } from "react";
import { Redirect } from "react-router";
import axios from "axios";
import Product from "./containers/ProductContainer";
import ProductList from "./containers/ProductList";
import { FETCH_STATUS } from "./constants";
import * as utils from "./utils";
import "./App.css";

class Store extends Component {
  storeName = null;
  state = {
    error: ""
  };
  handleSubmit = e => {
    e.preventDefault();
    let value = this.storeName.value;
    if (
      value
        .toLowerCase()
        .indexOf("https://www.teacherspayteachers.com/store/") == 0
    ) {
      if (value[value.length - 1] === "/") {
        value = value.substr(0, value.length - 1);
      }
      const store = value.substr(value.lastIndexOf("/") + 1);
      localStorage.setItem("tpt-store", store);
      window.location.reload(true);
    } else {
      this.setState({
        error:
          "Your full store URL should start with https://www.teacherspayteachers.com/Store/YOUR-STORE-NAME"
      });
    }
  };
  render() {
    return (
      <div className="store-container">
        <header>
          <div className="flex">
            <h3>Bearwood Labs</h3> | Product Description PRO
          </div>
          <div />
        </header>

        <main>
          <div>
            <h1>Get Started</h1>
            <p>Please enter your full store URL to get started</p>
            <hr />
            <form onSubmit={this.handleSubmit}>
              <div>
                <input
                  className="store-name"
                  type="text"
                  id="store"
                  ref={c => (this.storeName = c)}
                  placeholder="Your store URL"
                />
                <div>{this.state.error}</div>
              </div>
              <button type="submit" className="button button-primary">
                Go
              </button>
            </form>
          </div>
        </main>

        <footer />
      </div>
    );
  }
}
export default Store;



// WEBPACK FOOTER //
// ./src/Store.js